import { region } from "./region";
import {miniPersistStore} from "../models/MiniPersistStore";
import {
    ResBalanceData,
    ResRechargesData,
    ResRecharge, ResCouponData, ResBalanceAlertsData, ResBalanceAlertsUpData,
} from "../models/PriceStore";
import Fetcher from "@netless/fetch-middleware";
if (!process.env.CONSOLE_LAMBDA_ORIGIN) {
    throw new Error("need set process.env.CONSOLE_LAMBDA_ORIGIN");
}
const fetcher = new Fetcher(10000, process.env.CONSOLE_LAMBDA_ORIGIN);
export enum ConversionTimeEnum {
    day = "day",
    month = "month",
}

export enum WhiteboardEnum {
    room = "room",
    team = "team",
}
export class DataOperator {
    public async getRoomData(offset: number, limit: number): Promise<any> {
        const json = await fetcher.get<any>({
            path: "room",
            query: {
                token: miniPersistStore.token,
                offset: (offset - 1) * limit,
                limit: limit,
            },
            headers: {
                region,
            },
        });
        return json as any;
    }

    public async getRoomDataByUuid(uuid: string): Promise<any> {
        const json = await fetcher.get<any>({
            path: "room/uuid",
            query: {
                uuid: uuid,
                token: miniPersistStore.token,
            },
            headers: {
                region,
            },
        });
        return json as any;
    }

    public async getRoomDataDetail(uuid: string): Promise<any> {
        const json = await fetcher.get<any>({
            path: "room/detail/day",
            query: {
                room: uuid,
                token: miniPersistStore.token,
            },
            headers: {
                region,
            },
        });
        return json as any;
    }

    public async getRoomDataMinuteDetail(uuid: string, start: number, end: number): Promise<any> {
        const json = await fetcher.get<any>({
            path: "room/detail/minute",
            query: {
                room: uuid,
                start: start,
                end: end,
                token: miniPersistStore.token,
            },
            headers: {
                region,
            },
        });
        return json as any;
    }

    public async getBalanceData(): Promise<ResBalanceData> {
        const json = await fetcher.get<any>({
            path: "balance",
            query: {
                token: miniPersistStore.token,
            },
        });
        return json as ResBalanceData;
    }

    public async completedRechargesData(): Promise<ResRechargesData> {
        const json = await fetcher.get<any>({
            path: "recharges",
            query: {
                token: miniPersistStore.token,
                step: "completed",
            },
        });
        return json as ResRechargesData;
    }

    public async couponData(): Promise<ResCouponData> {
        const json = await fetcher.get<any>({
            path: "coupons",
            query: {
                token: miniPersistStore.token,
            },
        });
        return json as ResCouponData;
    }

    public async getBalanceAlertsData(): Promise<ResBalanceAlertsData> {
        const json = await fetcher.get<any>({
            path: "balance-alerts",
            query: {
                token: miniPersistStore.token,
            },
        });
        return json as ResBalanceAlertsData;
    }

    public async uploadBalanceAlertsData(alertType: string, alertLine: string): Promise<any> {
        const json = await fetcher.post<any>({
            path: "balance-alerts",
            body: {
                alertType: alertType,
                alertLine: alertLine,
            },
            query: {
                token: miniPersistStore.token,
            },
        });
        return json as any;
    }

    public async upDateBalanceAlertsData(alertType: string, alertLine: string, enable: boolean): Promise<ResBalanceAlertsUpData> {
        const json = await fetcher.put<any>({
            path: "balance-alerts",
            body: {
                alertType: alertType,
                alertLine: alertLine,
                enable: enable,
            },
            query: {
                token: miniPersistStore.token,
            },
        });
        return json as ResBalanceAlertsUpData;
    }

    public async getMyService(): Promise<any> {
        const json = await fetcher.get<any>({
            path: "services",
            query: {
                token: miniPersistStore.token,
            },
            headers: {
                region,
            },
        });
        return json as any;
    }


    public async rechargeWithAlipay(price: number): Promise<ResRecharge> {
        const json = await fetcher.post<any>({
            path: "alipay-recharges",
            query: {
                token: miniPersistStore.token,
            },
            body: {
                price: price,
            },
        });
        return json as ResRecharge;
    }

    public async checkByRechargeId(id: number): Promise<ResRecharge> {
        const json = await fetcher.get<any>({
            path: `recharges/${id}`,
            query: {
                token: miniPersistStore.token,
            },
        });
        return json as ResRecharge;
    }

    public async getBillsList(startTime: number, endTime: number): Promise<any> {
        const json = await fetcher.get<any>({
            path: `cloud-orders`,
            query: {
                token: miniPersistStore.token,
                step: "completed",
                startTime: startTime,
                endTime: endTime,
            },
        });
        return json as any;
    }

    // 计量数据
    public async getConversionData(serviceType: number, start: number, end: number, type: ConversionTimeEnum): Promise<any> {
        const json = await fetcher.get<any>({
            path: `conversion-service-list`,
            query: {
                serviceType: serviceType,
                start: start,
                end: end,
                type: type,
                token: miniPersistStore.token,
            },
            headers: {
                region,
            },
        });
        return json as any;
    }

    public async getWhiteboardData(start: number, end: number, type: WhiteboardEnum, uuid?: string): Promise<any> {
        const json = await fetcher.get<any>({
            path: `consumptions-duration`,
            query: {
                start: start,
                end: end,
                type: type,
                token: miniPersistStore.token,
                uuid: uuid,
            },
            headers: {
                region,
            },
        });
        return json as any;
    }

    // 计量数据
    public async getLogDataByUuid(uuid: string, start: number, end: number, page: number): Promise<any> {
        const json = await fetcher.get<any>({
            path: `room/logs`,
            query: {
                uuid: uuid,
                start: start,
                end: end,
                token: miniPersistStore.token,
                limit: 10,
                page: page,
            },
        });
        return json as any;
    }

}



// WEBPACK FOOTER //
// ./src/apiMiddleware/DataOperator.ts